
import React from 'react';
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

interface FAQSectionProps {
  faqs: FAQItem[];
  className?: string;
}

const FAQSection = ({ faqs, className = "" }: FAQSectionProps) => {
  return (
    <Accordion type="single" collapsible className={`w-full ${className}`}>
      {faqs.map((faq, index) => (
        <AccordionItem key={`faq-item-${index}`} value={`item-${index + 1}`}>
          <AccordionTrigger className="text-lg font-medium text-apple-text">
            {faq.question}
          </AccordionTrigger>
          <AccordionContent className="text-apple-text-secondary">
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FAQSection;
